window.vdSliderIrti = true;
window.vdSliderInstallConfig = {
    "sm": "a",
    "dt": "adapthmb",
    "at": "cho",
    "dp": null,
    "ap": null,
    "dc1": "0095FF",
    "dc2": "A6A6A6",
    "ac1": "000000",
    "dbg": null,
    "abg": "FFFFFF",
    "ev": 1,
    "em": 1,
    "ezc": 1,
    "ezh": 1,
    "eov": null,
    "ar": null,
    "dl": null,
    "pvi": 1,
    "haom": false,
    "saoh": 1,
    "haob": 1,
    "hod": null,
    "hom": null,
    "sta": null,
    "m": null,
    "v": 5,
    "i_si_rules": [".vd-slider-root {}", "@media (min-width: 768px) { .vd-slider-root { } }"],
    "i_m_ivonpl": true,
    "rti": true,
    "i_sr_ish_is": true,
    "ss": true,
    "zbgw": true
};
window.vdSliderInstallConfig.tc = {
    "i_mo_rs": ".grid__item.product__media-wrapper:not(.medium-hide)",
    "i_mo_rs_a": true,
    "i_cm": [{
        "c": "window.innerWidth < 750",
        "m": {
            "i_mo_rs": ".grid__item.product__media-wrapper:not(.small-hide)"
        }
    }]
}; 